import { Canvas } from 'fabric';

export class MnemonicGridRenderer {
    static readonly DEFAULT_GRID_SIZE = 35;

    static draw(canvas: Canvas | undefined, gridSize = MnemonicGridRenderer.DEFAULT_GRID_SIZE): void {
        if (!canvas) {
            return;
        }

        const ctx = canvas.contextContainer;
        const width = canvas.width;
        const height = canvas.height;

        ctx.save();
        ctx.beginPath();
        ctx.strokeStyle = '#cecece';
        ctx.globalCompositeOperation = 'destination-over';

        for (let x = 0; x <= width; x += gridSize) {
            ctx.moveTo(x + 0.5, 0);
            ctx.lineTo(x + 0.5, height);
        }

        for (let y = 0; y <= height; y += gridSize) {
            ctx.moveTo(0, y + 0.5);
            ctx.lineTo(width, y + 0.5);
        }

        ctx.stroke();
        ctx.restore();
    }

    static createAfterRenderHandler(getCanvas: () => Canvas | undefined, gridSize = MnemonicGridRenderer.DEFAULT_GRID_SIZE): () => void {
        return () => MnemonicGridRenderer.draw(getCanvas(), gridSize);
    }
}
